export {
    isValidAnnouncement,
    DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT,
    DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT,
} from './login-announcements';
